import get from 'lodash/get';
import playerStatuses from '../utils/playerStatuses';

const NAMESPACE = 'preroll';

export const selectIsPrerollDialogOpen = (state) =>
  get(state, [NAMESPACE, 'prerollDialogOpen']);
export const selectPlayerState = (state) =>
  get(state, [NAMESPACE, 'playerState']);
export const selectIsPrerollLoaded = (state) =>
  selectPlayerState(state) === playerStatuses.loaded;
